import { Typography } from '@mui/material'
import React from 'react'

export function FormbuilderLabel(props: React.PropsWithChildren<any>) {
  return <Typography variant="h6" {...props} />
}
